<template>
  <v-container class="py-8 bg-light-blue-main">
    <h1>User spaces</h1>
    <div class="d-flex flex-row ga-8 flex-wrap">
      <div
        v-for="space in mainStore.calculationSpaces"
        :key="space.id">
        <v-card
          :data-cy="`space-${space.id}`"
          style="padding-bottom: 50px">
          <v-card-item>
            <v-card-title>{{ space.name }} </v-card-title>
            <v-card-subtitle>
              <v-avatar
                color="secondary"
                v-for="user in space.users.filter((u) => u.isActive)"
                :key="user.id">
                {{ user.first_name[0] }}{{ user.last_name[0] }}
              </v-avatar>
            </v-card-subtitle>
            <v-card-subtitle>{{ space.description }} </v-card-subtitle>
            <template #append>
              <v-fab
                v-if="space.rights & SPACE_RIGHT_ADMIN"
                elevation="0"
                icon="mdi-cog"
                @click.prevent="editSpace(space.id)"></v-fab>

              <v-fab
                v-else
                elevation="0"
                icon="mdi-logout"
                @click.prevent="leaveSpace(space.id)"></v-fab>
            </template>
          </v-card-item>

          <v-card-text>
            <CostBreakDownSmall :spaceId="space.id" />
          </v-card-text>

          <v-card-actions style="position: absolute; bottom: 0; width: 100%">
            <v-spacer />
            <v-btn
              v-if="space.state === 1"
              elevation="3"
              data-cy="open-space"
              @click="goToSpace(space.id)"
              >Öffnen</v-btn
            >
            <template v-else>
              <v-btn
                elevation="3"
                data-cy="decline-invitation"
                @click="mainStore.declineInvitation(space.id)"
                >Ablehnen</v-btn
              >
              <v-btn
                elevation="3"
                data-cy="accept-invitation"
                @click="mainStore.acceptInvitation(space.id)"
                >Annehmen</v-btn
              >
            </template>
          </v-card-actions>
        </v-card>
      </div>

      <div>
        <v-card @click="spaceCreateDialog = true">
          <v-card-title>Neuen Calculation Space erstellen</v-card-title>
          <v-card-subtitle></v-card-subtitle>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="spaceEditDialog">
      <SpaceEdit
        :space-id="spaceEditId"
        @close="spaceEditDialog = false" />
    </v-dialog>

    <v-dialog v-model="spaceCreateDialog">
      <SpaceCreate @close="spaceCreateDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/mainStore";
import { ref } from "vue";
import { useRouter } from "vue-router";
import SpaceEdit from "@/components/dialogs/SpaceEdit.vue";
import { SPACE_RIGHT_ADMIN } from "@/utils/constants";
import CostBreakDownSmall from "./CostBreakDownSmall.vue";
import SpaceCreate from "@/components/dialogs/SpaceCreate.vue";
import { useTranslation } from "i18next-vue";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { useConfirmComposable } from "@/utils/confirmComposable";

const { t } = useTranslation();
const createSnackbar = useSnackbar();
const createConfirm = useConfirm();
const mainStore = useMainStore();
const router = useRouter();
const confirm = useConfirmComposable();

const spaceEditDialog = ref(false);
const spaceEditId = ref(null);
const spaceCreateDialog = ref(false);

const name = ref("");
const description = ref("");

const collaborator = ref("");

const goToSpace = (spaceId: number) => {
  router.push(`/calc/${spaceId}`);
};

const createSpace = () => {
  // mainStore.createSpace(name.value, description.value);
  // createSpaceActive.value = false;
};

const editSpace = (spaceId: number) => {
  spaceEditId.value = spaceId;
  spaceEditDialog.value = true;
};

const addCollaborator = (spaceId: number) => {
  mainStore.addCollaborator(collaborator.value, spaceId);
};

function leaveSpace(spaceId: string) {
  confirm("remove-space").then(() => {
    mainStore.removeSpace(spaceId);
  });
}
</script>

<style scoped lang="scss">
.v-card {
  width: 400px;
  height: 400px;
}
</style>
